// import posterData from '../data/convertcsv.json';
import React, { useState, useEffect } from 'react';
import ScrollToTop from 'react-scroll-up';

// import { Document } from 'react-pdf';

import { Navbar, Nav, Container, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowUp, faGripHorizontal, faSearch, faFilter, faClone, faVideo, faDesktop, faScroll } from '@fortawesome/free-solid-svg-icons';

function PosterList() {

    const sw = require('stopword');

    const [typeName, setType] = useState('');
    const [venueName, setVenue] = useState('');
    const [uPoster, setPoster] = useState('');
    const [imageFile, setImage] = useState('');
    const [show, setShow] = useState(false);
    const [filtered, setFilter] = useState(false);
    const [tags, setTags] = useState(false);
    const [activeTag, setActive] = useState([]);
    const [keyword, setSearch] = useState(false);


    const [meetingTitle, setMeetingTitle] = useState('');
    const [meetingID, setMeetingID] = useState('');
    const [passcode, setPasscode] = useState('');
    const [meetingURL, setMeetingURL] = useState('');
    
    const [posterData, getData] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const posterData2 = () =>{
        fetch('data/convertcsv.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            // console.log('response: ', response)
            return response.json();
          })
          .then(function(myJson) {
            getData(myJson);
          });
      }

      
        useEffect( () => {
            posterData2()
        },[] )
          

    const posterType = [...new Set(posterData.map(data => data.event_type ))];
    // console.log('type', posterType);
    
    const posterRoom = [...new Set(posterData.map(data => data.venue ))];
    // console.log('room', posterRoom);

    const posterU = [...new Set(posterData.map(data => data.Submission_no ))];

    const posterTags = [...new Set(posterData.map(data => data.sessionTags ))];
    // console.log('tags', posterTags);

    const posterAllTags = posterTags.map(data => data.split(','));
    // console.log('all tags', posterAllTags);

    const posterAllTagList = [].concat.apply([], posterAllTags);
    // console.log('all list', posterAllTagList);

    const posterTagList = [...new Set(posterAllTagList.map(data => data))];
    // console.log('tag list', posterTagList);

    const filteredCollection = posterData.filter( collection =>{
        if (keyword) {
            const keywordString = keyword.toLowerCase().trim().replace(/\s/g, ',').split(',');
            // const keywordsArr = keywordString.toLowerCase().trim().replace(/\s/g, ',').split(',');
            const keywordsArr = sw.removeStopwords(keywordString);
            // console.log('search: ', keywordsArr);

            if (typeName) {
                return ( keywordsArr.some(v => collection.name.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.description.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.speakers.toLowerCase().includes(v)) ) && 
                collection.event_type === typeName
            }
            else if (venueName) {
                return ( keywordsArr.some(v => collection.name.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.description.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.speakers.toLowerCase().includes(v)) ) && 
                collection.venue === venueName
            }
            else if (uPoster) {
                return ( keywordsArr.some(v => collection.name.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.description.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.speakers.toLowerCase().includes(v)) ) && 
                collection.Submission_no === uPoster
            }
            else if (tags) {
                return ( keywordsArr.some(v => collection.name.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.description.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.speakers.toLowerCase().includes(v)) ) && 
                activeTag.every(v => collection.sessionTags.includes(v))
            }
            else {
                return keywordsArr.some(v => collection.description.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.name.toLowerCase().includes(v)) ||
                keywordsArr.some(v => collection.speakers.toLowerCase().includes(v)) 
                
            }
        } else if (typeName) {
            if (venueName) {
                return collection.event_type === typeName && collection.venue === venueName
            }
            else if (uPoster) {
                return collection.event_type === typeName && collection.Submission_no === uPoster
            }
            else if (tags) {
                return collection.event_type === typeName && activeTag.every(v => collection.sessionTags.includes(v))
            }
            else {
                return collection.event_type === typeName
            }
        } else {
            if (venueName) {
                return collection.venue === venueName
            }
            else if (uPoster) {
                return collection.Submission_no === uPoster
            }
            else if (tags) {
                return activeTag.every(v => collection.sessionTags.includes(v))
            }
            else {
                return posterData
            }
        }
    })

    function clearSearch() {
        const searchInput = document.getElementsByTagName('input');
        console.log('input ', searchInput);
        searchInput[0].value = '';
    }

    function clearSelected(group) {
        var i;
        if(!group) {
            group = 'selected'
        } 
        // console.log('clear ', group)
        const filteredList = document.getElementsByClassName(group);
        for(i=0; i<filteredList.length; i++) {
            filteredList[i].classList.remove('selected');
        }
    }

    function filterList(id) {

        // document.getElementById(id).classList.toggle('selected');

        // console.log('clicked ', id);

        const indexTag = activeTag.indexOf(id);
        // console.log('position ', indexTag);

        if (indexTag > -1) {
            // setActive(activeTag.splice(indexTag, 1));
            let newArr = [...activeTag];
            newArr[indexTag] = '';
            setActive(newArr);
            // console.log('remove');
        } else {
            setActive(activeTag.concat(id));
            // console.log('add');
        }

    }

    useEffect(() => {
        if (activeTag.length > 0) {
            setFilter(true);
            setTags(true);
            
        }
        else {
            setFilter(false);
            setTags(false);
        }

        // console.log(activeTag);
    }, [activeTag]);

    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

    return (
        <>
        <Navbar className="pagesLink noselect" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand><img className="CUHKlogo" src={`${process.env.PUBLIC_URL}/images/cuhk_logo.png`} alt="CUHK" /><span className="name">Teaching and Learning Innovation Expo 2021</span> <span className="divider">-</span> <span className="subName">Digital Poster Exhibition</span></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav>
                <Nav.Link className="btn" onClick={() => {
                        setType('');
                        setSearch('');
                        setActive(['']);
                        setVenue('');
                        clearSelected();
                        document.getElementsByClassName('navbar-toggler')[0].click();
                        window.scrollTo(0, 0);
                    }}>All</Nav.Link>
                {
                    posterType.sort().map(d => (<Nav.Link key={d.index} className="btn" onClick={() => {
                        setType(d);
                        setSearch('');
                        setActive(['']);
                        setVenue('');
                        clearSelected();
                        document.getElementsByClassName('navbar-toggler')[0].click();
                        window.scrollTo(0, 0);
                    }}>{d}</Nav.Link>))
                }
            </Nav>
          </Navbar.Collapse>
          </Container>
        </Navbar>
        <Container className="content">
        {/* <div>{posterType.length} Type(s) Found</div> */}
        <ScrollToTop className="scrollTop" showUnder={160} >
            <FontAwesomeIcon icon={faArrowUp} />
        </ScrollToTop>
        <div className="intro">
            {/* <p className="title">Interactive Session for the Digital Poster Exhibition</p> */}
            {/* <p>The Interactive Session for the Digital Poster Exhibition will be held on 28 July 2021, from 12:45 to 14:00 (Hong Kong Time).</p>
            <p>The session is divided into TWO breakout sessions. Poster presenters will be in the zoom meeting room during the designated breakout session, to meet with participants and answer their questions toward the poster. Click “Join the Meeting” button placed below each of the poster abstract and have a live zoom chat with the presenter(s) of the poster you are interested in.</p> */}
            <p>Congratulations to the poster award winners at the Teaching and Learning Innovation Expo 2021!</p>
            <p>Click the following link to view all the award-winning posters and their corresponding videos at once: <a className="posterAwards" href="https://www.cuhk.edu.hk/eLearning/expo2021/poster-awards">https://www.cuhk.edu.hk/eLearning/expo2021/poster-awards</a></p>
            <p className="title">Poster Awards</p>
            <ul>
                {/* <li>Two Q&amp;A Sessions for shortlisted candidates of Poster Awards scheduled on (i) 26 July from 14:00 to 15:40 (Online Venue: Room B) and (ii) 27 July from 15:40 to 16:35 (Online Venue: Room B). </li>
                <li>For the detailed rundown of the two sessions, please click <a className="posterAwards" href="https://www.cuhk.edu.hk/eLearning/expo2021/poster-qas-rundown.pdf" target="_blank" rel="noopener noreferrer">here.</a></li> */}
                <li>Click the "#Shortlisted" tag for viewing the shortlisted posters.</li>
            </ul>
            <p className="title">Members of the Poster Awards Judging Panel</p>
            <ul>
                <li>Professor Chetwyn CHAN, Vice President (Research and Development), The Education University of Hong Kong </li>
                <li>Professor Ricky KWOK, Vice President (Students and Support), The Open University of Hong Kong</li>
                <li>Professor Carmel McNAUGHT, Emeritus Professor of Learning Enhancement, Centre for Learning Enhancement And Research, The Chinese University of Hong Kong </li>
            </ul>
            <p className="title">Notes</p>
            <ul>
                {/* <li>All sessions listed in the event programme are scheduled in Hong Kong Time (UTC/GMT+8).</li> */}
                <li>Filters are available for filtering posters by Session or by institutions (#CUHK / #Sister Universities). </li>
                {/* <li>Filters are available for filtering posters by Session (#Breakout 1: 28 July 12:45 - 13:20 / #Breakout 2: 28 July 13:25 - 14:00) or by institutions (#CUHK / #Sister Universities). </li> */}
            </ul>
            <p className="title">Useful links</p>
            <ul>
                <li>Expo 2021 website: <a href="https://www.elearning.cuhk.edu.hk/expo2021" target="_blank" rel="noopener noreferrer">https://www.elearning.cuhk.edu.hk/expo2021</a></li>
                <li>Event programme: <a href="https://www.elearning.cuhk.edu.hk/expo2021-programme" target="_blank" rel="noopener noreferrer">https://www.elearning.cuhk.edu.hk/expo2021-programme</a></li>
                {/* <li>Event access: <a href="https://www.elearning.cuhk.edu.hk/expo2021-event-access" target="_blank" rel="noopener noreferrer">https://www.elearning.cuhk.edu.hk/expo2021-event-access</a> (password: expo2021)</li> */}
            </ul>
        </div>
        <div className="tracks" id="tracks">
            <div className="subTitle">Areas of Interest <FontAwesomeIcon icon={faGripHorizontal} /></div>
            <div className="typeList">
                <Row className="typeBtns">
                    <Col className="btn" onClick={() => {
                        setType('');
                        setActive(['']);
                        setPoster('');
                        setVenue('');
                        setSearch('');
                        clearSearch();
                        clearSelected();
                        document.getElementById('tracks').scrollIntoView({ behavior: 'smooth' });
                    }}>All</Col>
                    {posterType.sort().map(d => (<Col key={d.index} id={d.replace(/ /g,'')} className="btn" onClick={() => {
                        setType(d);
                        setActive(['']);
                        setPoster('');
                        setVenue('');
                        setSearch('');
                        clearSearch();
                        clearSelected();
                        document.getElementById('tracks').scrollIntoView({ behavior: 'smooth' });
                        // document.getElementById(d.replace(/ /g,'')).classList.toggle('selectedType');
                    }}>{d}</Col>))} 
                </Row>
            </div>
        </div>
        <div className="subTitle" id="search">Search <FontAwesomeIcon icon={faSearch} /></div>
        <div className="searchDiv">
        <Form.Control type="text" name="keyword" onChange={
            e => setSearch(e.target.value)
        } />
        </div>
        {/* <div>{posterRoom.length} Room(s) Found</div> */}
            <div className="subTitle">Filter displayed posters <FontAwesomeIcon icon={faFilter} /></div>
            <div className="filterList">
                <Row>
                    <Col>
                        <div className="tagsList">
                            <div className="subTitle">Session</div>
                            {posterRoom.sort().map(d => (<div key={d.index} id={d.replace(/ /g,'')} className="btn venueRoom" onClick={() => {
                                            // filterList(d.replace(/ /g,''));
                                            // filterRoom(d.replace(/ /g,''));
                                            setVenue(d);
                                            setPoster('');
                                            setActive(['']);
                                            clearSelected('');
                                            clearSelected('tagsBtn');
                                            document.getElementById(d.replace(/ /g,'')).classList.add('selected');
                                            document.getElementById('search').scrollIntoView({ behavior: 'smooth' });
                            }}>{d}</div>))} 
                        </div>
                    </Col>
                    <Col>
                        <div className="tagsList">
                            <div className="subTitle">Submission</div>
                            {posterU.sort().map(d => (<div key={d.index} id={d.replace(/ /g,'')} className="btn uPoster" onClick={() => {
                                            // filterList(d.replace(/ /g,''));
                                            // filterRoom(d.replace(/ /g,''));
                                            setPoster(d);
                                            setVenue('');
                                            setActive(['']);
                                            clearSelected('');
                                            clearSelected('tagsBtn');
                                            document.getElementById(d.replace(/ /g,'')).classList.add('selected');
                                            document.getElementById('search').scrollIntoView({ behavior: 'smooth' });
                            }}>{d}</div>))} 
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="tagsList hashTag">
                            <div className="subTitle">Tags</div>
                            {
                            posterTagList.sort().map(d => (<div key={d.index} id={d} className="btn tagsBtn" onClick={() => {
                                setVenue('');
                                setPoster('');
                                filterList(d);
                                clearSelected('venueRoom');
                                clearSelected('uPoster');
                                document.getElementById(d).classList.toggle('selected');
                                document.getElementById('search').scrollIntoView({ behavior: 'smooth' });
                            }
                            }>{d}</div>))} 
                        </div>
                    </Col>
                </Row>
            </div>

        <div className="subTitle">{typeName ? typeName : "All Posters"} <FontAwesomeIcon icon={faClone} /></div>
        <div>{filteredCollection.length} Poster(s) displayed</div>
        <div id="posterContent" className={filtered ? 'filtered' : ''}>
        {filteredCollection.sort((a, b) => a.event_key > b.event_key ? 1 : -1).map((collection, i) => (
            <div key={i} className={ collection.venue.replace(/ /g,'') + ` ` + collection.sessionTags.replace(/,/g,' ') + ` resultList` }>
                <Row className="posterItem">
                    <Col className="posterImage">
                        { collection.media_url ?
                            <img src={collection.media_url} alt={collection.name} onClick={() => {
                                handleShow(true);
                                setImage(collection.media_url);
                            }} />
                            :
                            // <Document
                            //     file={{ url: collection.media_url}}
                            // ></Document>
                            ''
                        }
                    </Col>
                    <Col className="posterInfo">
                        <div className="title">
                            <div>{collection.name}</div>
                        </div>
                        <div className="speaker">
                            <span className="subtitle">Presented by</span>
                            <div>{renderHTML(collection.speakers.replace(/;/g, "<br>"))}</div>
                        </div>
                        <div className="desc">
                            <span className="subtitle">Abstract</span>
                            <div>{renderHTML(collection.description)}</div>
                        </div>
                        { collection.video_stream ?

                            <div className="video">
                                <span className="subtitle">Video Stream</span>
                                <div className="videoLinks">
                                    <div className="btn videoStream"><a href={ collection.video_stream } target="_blank" rel="noopener noreferrer" >Video <FontAwesomeIcon icon={faVideo} /></a></div>
                                    { collection.Video2 ?
                                        <div className="btn videoStream"><a href={ collection.Video2 } target="_blank" rel="noopener noreferrer" >Video <FontAwesomeIcon icon={faVideo} /></a></div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>
                            :
                            ''
                        }
                        { collection.paper_url ?

                        <div className="paper">
                            <span className="subtitle">Short Paper</span>
                            <div className="paperLinks">
                                <div className="btn paperURL"><a href={ collection.paper_url } target="_blank" rel="noopener noreferrer" >Open <FontAwesomeIcon icon={faScroll} /></a></div>
                            </div>
                        </div>
                        :
                        ''
                        }
                        <div className="venue">
                            <span className="subtitle">Session</span>
                            <div>{collection.venue}</div>
                        </div>
                        {
                            collection.sessionTags ?
                                <div className="tags">
                                    <span className="subtitle">Hashtags</span>
                                    <div className="tagsList">{renderHTML(`<span>#` + collection.sessionTags.replace(/,/g, "</span> <span>#") + `</span>`)}</div>
                                </div>
                            :
                            ''
                        }
                        
                        <div className="actionBtn">
                            {
                                collection.MeetingID ?
                                <div className="btn meeting" onClick={() => {
                                    handleShow(true);
                                    setImage('');
                                    setMeetingTitle(collection.name);
                                    setMeetingID(collection.MeetingID);
                                    setPasscode(collection.Passcode);
                                    setMeetingURL(collection.MeetingURL);
                                }}>Join the Meeting <FontAwesomeIcon icon={faDesktop} /></div>
                                :
                                ''
                            }
                            {/* <div className="btn presentation">Watch Presentation</div> */}
                        </div>
                        <div className="tracks">
                            <span className="subtitle">Areas of Interest</span>
                            <div>{collection.event_type}</div>
                        </div>
                    </Col>
                </Row>
            </div>
        ))}
        </div>
        </Container>
        <div className="footer">
            <Container>
                <span>&copy; The Chinese University of Hong Kong. All Rights Reserved.</span>
            </Container>
        </div>
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <FontAwesomeIcon icon={faTimes} onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
                { imageFile ? 
                    <img src={imageFile.replace('img', 'img-fullsize')} alt="Poster" />
                    :
                    <>
                    <div className="meetingTitle"><span>{meetingTitle}</span></div>
                    <div className="meetingID"><span>Meeting ID:</span> { meetingID }</div>
                <div className="meetingPassCode"><span>Passcode:</span> { passcode }</div>
                    <div className="meetingURL"><a href={ meetingURL } target="_blank" rel="noopener noreferrer" ><Button className="btn">Join the Meeting <FontAwesomeIcon icon={faDesktop} /></Button></a></div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            </Modal.Footer>
            </Modal>
        </>
    );
}

export default PosterList;
